export default __webpack_public_path__ + "0697eabfedc195b0f844bb6c92388ac8.png";